import styles from './average-csat-score.module.scss';

export const getArrowColor = (change?: number) => {
  if (change === 0) {
    return styles.neutral;
  }
  if (change === undefined) return '';

  const isPositive = change > 0;

  return isPositive ? styles.increase : styles.decrease;
};
